<ng-container *ngIf="control; else skeleton">
<dk-ctl-sablon #sablonCmp
  [isReadOnly]="isReadOnly" [labelText]="labelText" [labelMode]="labelMode" [title]="title" [code]="code"
  (handleValueChange)="handleValueChange($event)" (codeChanges)="code = $event" [validationRules]="validationRulesMap"
  (searchClick)="searchClick()"  [validationV2]="validationV2" [warningMessage]="warningMessage"
  (clear)="clear()">
</dk-ctl-sablon>
<dx-popup *ngIf="crudPopupVisible"
          title="Gelir Arama"
          [resizeEnabled]="false"
          [hideOnOutsideClick]="false"
          [showCloseButton]="true"
          [(visible)]="crudPopupVisible"
          (onHiding)="closePopupAfter($event, sablonCmp)"
>
  <dk-ctl-teb-gelir-arama
    [control]="control"
    (closePopup)="closePopupAfter($event, sablonCmp)"
  ></dk-ctl-teb-gelir-arama>
</dx-popup>
<dx-toast [(visible)]="toastVisible" type="error" [message]="toastMessage">
</dx-toast>
</ng-container>
<ng-template #skeleton>
  <div class="skeleton-control"></div>
</ng-template>
